import React from 'react';
import PropTypes from 'prop-types';

import { PowerFunnelSurfaces } from '../../Analytics/constants';
import useIsMobile from '../../hooks/useIsMobile';
import useGlobalPrivilegesCta from '../../hooks/useGlobalPrivilegesCta';
import styles from './globalPrivilegesBanner.scss';

const GlobalPrivilegesBanner = ({ surface = PowerFunnelSurfaces.HOME }) => {
    const { isMobileWidth } = useIsMobile();
    const {
        buttonText,
        hasPastDueSubscription,
        pastDueSubscriptionMessage,
        handleCtaClick,
        handleLearnMoreClick,
    } = useGlobalPrivilegesCta({ surface, trackImpressions: true });

    return (
        <div className={styles.globalPrivilegesBanner}>
            <div className={styles.bannerInner}>
                <div className={styles.contentSection}>
                    <p className={styles.headline} data-testid="banners.global-privileges.headline">
                        Your Tennis Passport is Waiting.
                    </p>
                    <p className={styles.subhead} data-testid="banners.global-privileges.subhead">
                        Upgrade to Power and get $250 in travel value instantly.
                    </p>
                    <p className={styles.body} data-testid="banners.global-privileges.body">
                        From court-side at world-class resorts to airport lounge access,
                        this membership pays for itself before you even swing a racket.
                    </p>
                    {hasPastDueSubscription && <p className={styles.pastDueMessage} data-testid="banners.global-privileges.past-due-message">{pastDueSubscriptionMessage}</p>}
                    <button
                        className={styles.ctaButton}
                        onClick={handleCtaClick}
                        type="button"
                        data-testid="banners.global-privileges.cta-btn"
                    >
                        {buttonText}
                    </button>
                    <div
                        className={styles.learnMore}
                        onClick={handleLearnMoreClick}
                        data-testid="banners.global-privileges.learn-more"
                    >
                        <span className={styles.underline} data-testid="banners.global-privileges.learn-more-link">Learn more</span>
                        {' about '}
                        <img
                            src="/img/v3/graphics/perks/global-privileges/global-privileges-logo.png"
                            alt="Global Privileges"
                            className={styles.gpLogo}
                            data-testid="banners.global-privileges.gp-logo"
                        />
                    </div>
                </div>
                <div className={styles.imageSection}>
                    <img
                        src={isMobileWidth
                            ? '/img/v3/graphics/perks/global-privileges/tennis-passport-mobile.png'
                            : '/img/v3/graphics/perks/global-privileges/tennis-passport.png'}
                        alt="Man with tennis bag at airport gate"
                        className={styles.bannerImage}
                        data-testid="banners.global-privileges.banner-image"
                    />
                </div>
            </div>
        </div>
    );
};

GlobalPrivilegesBanner.propTypes = {
    surface: PropTypes.oneOf([PowerFunnelSurfaces.HOME, PowerFunnelSurfaces.POWER_PERKS_PAGE]),
};

GlobalPrivilegesBanner.defaultProps = {
    surface: PowerFunnelSurfaces.HOME,
};

export default GlobalPrivilegesBanner;
